import { render, staticRenderFns } from "./_administrative_fees.vue?vue&type=template&id=4ab98e50&lang=pug"
import script from "./_administrative_fees.vue?vue&type=script&lang=js"
export * from "./_administrative_fees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports